var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"owal spinner logo",attrs:{"src":require("../assets/img/OSquareNoPadding.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }